import React from 'react';
import { createRoot } from 'react-dom/client';

import { isSize, Size } from 'common/components/UserRating';
import readAttribute from 'common/tools/dom/readAttribute';

import StandaloneRating, {
  StandaloneRatingProps
} from 'website/components/push/Ratings/StandaloneRating';
import allocineContainer from 'website/containers/allocineContainer';

export default function () {
  const ConnectedStandaloneRating =
    allocineContainer<StandaloneRatingProps>(StandaloneRating);
  const anchors = document.getElementsByClassName('js-rating-title');

  if (anchors.length) {
    for (const anchor of anchors) {
      const entityId = readAttribute<string, undefined>(
        anchor,
        'data-entity-id'
      );
      if (entityId) {
        // if entity is series_season or series_episode, we need to get entity series for tracking
        const baseEntityId = readAttribute<string, undefined>(
          anchor,
          'data-base-entity-id'
        );
        const size = readAttribute<Size, undefined>(anchor, 'data-size');
        const title = readAttribute<string, undefined>(anchor, 'data-title');
        const showTitle = title !== null;

        const root = createRoot(anchor);
        root.render(
          <ConnectedStandaloneRating
            baseEntityId={baseEntityId}
            entityId={entityId}
            size={isSize(size) ? size : undefined}
            title={title}
            showTitle={showTitle}
          />
        );
      }
    }
  }
}
